import { Flex, Icon, SkeletonBox, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { BookkeepingItem as BookkeepingItemType } from '@features/reconciliation/types/bookkeepingItem'
import { BankLine } from '@modules-deprecated/bankReconciliation/types'

import { useBankTransactionDrawer } from '../../../../contexts'
import { BookkeepingItem } from '../BookkeepingItem'
import { TransactionItem } from '../TransactionItem'
import * as Styled from './styles'

interface MatchedStateProps {
  associatedBookkeepingItems?: BookkeepingItemType[]
  isLoading?: boolean
  linkedBankLines?: BankLine[]
}

export const MatchedState = ({
  associatedBookkeepingItems,
  isLoading,
  linkedBankLines,
}: MatchedStateProps): ReactElement => {
  const { t } = useTranslation()
  const { currency } = useBankTransactionDrawer()

  const hasBookkeepingItems = associatedBookkeepingItems && associatedBookkeepingItems.length > 0
  const hasLinkedTransactions = linkedBankLines && linkedBankLines.length > 0

  if (isLoading) {
    return <SkeletonBox fullWidth height={30} />
  }

  if (!hasBookkeepingItems && !hasLinkedTransactions) {
    return <></>
  }

  return (
    <>
      <Styled.TitleWrapper>
        <Flex gap={Spacing.S16} alignItems="center">
          <Icon icon="circleCheck" size="md" color="currentColor" />
          <Text weight="medium">{t('bank_transactions.drawer.matched_state_title')}</Text>
        </Flex>
      </Styled.TitleWrapper>
      {hasBookkeepingItems && (
        <>
          <Text weight="medium">{t('bank_transactions.drawer.matched_state_subtitle')}</Text>
          {associatedBookkeepingItems.map((item) => (
            <BookkeepingItem key={item.id} bookkeepingItem={item} isOutlined />
          ))}
        </>
      )}
      {hasLinkedTransactions && (
        <>
          <Text weight="medium">
            {t(
              linkedBankLines.length === 1
                ? 'bank_transactions.drawer.matched_state_linked_transaction_subtitle'
                : 'bank_transactions.drawer.matched_state_linked_transactions_subtitle',
            )}
          </Text>
          {linkedBankLines.map((line) => (
            <TransactionItem key={line.id} transactionItem={line} currency={currency} isOutlined showSignedAmount />
          ))}
        </>
      )}
    </>
  )
}
